import {
  LoadingWraper,
  LoadingCircle,
} from './styles';

function Loading() {
  return (
    <LoadingWraper>
      <LoadingCircle/>
    </LoadingWraper>
  );
}

export default Loading;
